<template>
  <!-- This is meant for Admin based contextual -->
  <span>
    <span><span class="setting-icon" @click="show_setting_modal"></span></span>
    <modal
      :name="settings_modal_name"
      height="auto"
      width="360px"
      style="z-index:9999;"
      v-if="!_isEmpty(options)"
      @after-close="on_modal_after_close"
    >
      <div class="modal_close_cont">
        <button @click="$modal.hide(settings_modal_name)"></button>
      </div>
      <div class="mbox bg-light shadow mb0">
        <div class="col-cont settings-cont">
          <div class="col">
            <div class="form">
              <div class="validation_errors_cont"></div>

              <form-row
                v-if="options.includes('cal_conflict_free_as_busy')"
                :validator="$v.form.cal_conflict_free_as_busy"
              >
                <label style="text-align: center;">{{
                  T__("Conflict calendar settings")
                }}</label>
                <label class="label-cb"
                  ><input
                    type="checkbox"
                    true-value="1"
                    false-value="0"
                    v-model="form.cal_conflict_free_as_busy"
                  />
                  {{ T__("Consider all calendar events are busy.") }}</label
                >
                <span class="txt-help"
                  >{{
                    T__(
                      "When unchecked, busy events in the calendar are seen as conflicts, and overlapping time slots are automatically removed to avoid conflicts. If this option is checked, events marked as free will also be treated as busy."
                    )
                  }}
                  <br />
                  <br />
                  {{
                    T__(
                      "Note: In Google Calendar by default all day events are marked as free."
                    )
                  }}</span
                >
              </form-row>

              <div class="wpc-form-row">
                <button
                  type="button"
                  class="wpc-btn primary lg mt20"
                  @click="form_submit"
                  style="width:100%"
                  :disabled="!save_btn_is_enabled"
                >
                  {{ T__("Save") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </span>
</template>

<script>
import { in_array } from "@/utils/common_func.js";

import axios from "axios";

export default {
  name: "SettingAdminContext",
  props: {
    options: {
      type: Array
    },
    settings_name: {
      type: String
    }
  },
  data() {
    return {
      form: {
        cal_conflict_free_as_busy: "0"
      },
      saved_admin_settings: this.clone_deep(this.form),
      save_btn_is_enabled: true
    };
  },
  computed: {
    settings_modal_name() {
      return this.settings_name + "_modal";
    }
  },
  validations: {
    form: {
      cal_conflict_free_as_busy: {
        cal_conflict_free_as_busy_in_array: in_array(["1", "0"])
      }
    }
  },
  methods: {
    load_page() {
      let wpcal_request = {};
      let action_get_admin_settings = "get_admin_settings_of_current_admin";
      wpcal_request[action_get_admin_settings] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          if (response.data[action_get_admin_settings]?.status == "success") {
            this.form = response.data[action_get_admin_settings].admin_settings;
            this.saved_admin_settings = this.clone_deep(this.form);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    form_submit() {
      this.clear_validation_errors_cont();
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.scroll_to_first_validation_error();
        return false;
      }

      this.save_btn_is_enabled = false;

      let action_update_admin_settings =
        "update_admin_settings_of_current_admin";
      let wpcal_request = {};
      wpcal_request[action_update_admin_settings] = {
        admin_settings: this.form
      };

      let action_get_admin_settings = "get_admin_settings_of_current_admin";
      wpcal_request[action_get_admin_settings] = {
        dummy__: ""
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          this.notify_single_action_result(
            response.data[action_update_admin_settings],
            { success_msg: this.T__("Settings saved.") }
          );

          if (
            response.data &&
            response.data[action_get_admin_settings].hasOwnProperty(
              "admin_settings"
            )
          ) {
            this.form = response.data[action_get_admin_settings].admin_settings;
            this.saved_admin_settings = this.clone_deep(this.form);
            setTimeout(() => {
              this.close_setting_modal();
            }, 200);
          }
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.save_btn_is_enabled = true;
        });
    },
    on_mounted() {
      // if (!this._isEmpty(this.options)) {
      //   this.$modal.show(this.settings_modal_name);
      // }
    },
    on_modal_after_close() {
      this.$emit("settings-modal-closed", "");
      this.$destroy();
    },
    show_setting_modal() {
      this.$modal.show(this.settings_modal_name);
    },
    close_setting_modal() {
      this.$modal.hide(this.settings_modal_name);
    }
  },
  mounted() {
    this.load_page();
  },
  watch: {}
};
</script>
<style scoped>
.setting-icon::before {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14.95 13.55'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;stroke:%23131336;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Regular'%3E%3Ccircle class='cls-1' cx='7.48' cy='6.78' r='1.5'/%3E%3Cpath class='cls-1' d='M5.69,1.11l1.11,1a1,1,0,0,0,1.35,0l1.11-1a1.33,1.33,0,0,1,2.21,1.28l-.34,1.48a1,1,0,0,0,.68,1.18l1.45.45a1.34,1.34,0,0,1,0,2.56l-1.45.44a1,1,0,0,0-.68,1.17l.34,1.48a1.33,1.33,0,0,1-2.21,1.27l-1.1-1a1,1,0,0,0-1.36,0l-1.11,1a1.34,1.34,0,0,1-2.21-1.29l.34-1.48a1,1,0,0,0-.68-1.18L1.7,8A1.33,1.33,0,0,1,.81,6.36a1.37,1.37,0,0,1,.88-.89L3.14,5a1,1,0,0,0,.68-1.18L3.48,2.38a1.31,1.31,0,0,1,1-1.59A1.34,1.34,0,0,1,5.69,1.11Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  position: absolute;
  width: 14px;
  height: 13px;
  opacity: 0.5;
  margin: 3px 2px;
  cursor: pointer;
}
</style>
